export default "__VITE_ASSET__tr59jXrt__"